<template>
  <!-- FIXME - Remove category-info class because it's a stupid global style -->
  <div class="category-info flexRow">
    <div v-if="!isValidCategory">
      <!-- EVENTUALLY REMOVE ME BECAUSE WE ARE LOADING OTHER SUMMARY STATS -->
    </div>

    <div v-else :class="isMobile() ? 'flexRow' : ''">
      <div class="metadata flexRow">
        <div class="block" :style="blockColorString" />
        <!-- FIXME - Do something more elegant than this -->

        <div class="metadataHeader flexRow">
          <div>
            <span>
              {{ getCategoryName(categoryId) }}
            </span>
            <edit-category-trigger class="editIcon" :categoryId="categoryId" />
          </div>
          <span class="lastBlock">
            {{ timeSinceLastBlock }}
          </span>
        </div>
      </div>

      <!-- FIXME/TODO - Test this with very large values -->
      <!-- FIXME/TODO - READD CATEGORY STATS -->
      <div v-if="!isMobile()" class="categoryStats flexRow">
        <div class="label">
          Blocks
        </div>

        <div class="countBlock" v-for="(count, timeframe) in categoryTotals">
          <div class="blockCount">
            {{ count }}
          </div>
          <div class="timeframe">
            {{ timeframe }}
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="todayTimeline"> -->
    <!-- Today -->
    <!-- Timeline goes here -->
    <!-- </div> -->

    <!-- TODO - Include block timelines for the day here (see when the days blocks were added) -->
    <!-- This will save me from having to hover over a block to see when I added the last one -->

    <!-- DO SOMETHING SPECIAL FOR PARENT CATEGORIES -->

    <!-- Overall rating compared to previous days -->

    <!-- EVENTUALLY REMOVE ME BECAUSE WE ARE LOADING OTHER SUMMARY STATS -->
    <block-graph v-if="isValidCategory && !isMobile()" :categoryId="categoryId" />
  </div>
</template>

<script>
import EditCategoryTrigger from "./EditCategoryTrigger.vue";
import BlockGraph from "./BlockGraph.vue";

import db from "../db.js";
import util from "../util.js";
import categoryUtil from "../categoryUtil.js";

export default {
  name: "category-details",
  mixins: [categoryUtil.getMixin(), util.getMobileMixin()],
  components: {
    "edit-category-trigger": EditCategoryTrigger,
    "block-graph": BlockGraph,
  },
  props: ["categoryId"],
  data() {
    return {
      now: Date.now(),
    };
  },
  created() {
    setInterval(() => {
      this.$data.now = Date.now();
    }, 5000);
  },
  computed: {
    isValidCategory() {
      return categoryUtil.getIsValidCategory(this.categoryId);
    },
    blockColorString() {
      return "background-color: " + util.colors[categoryUtil.getColor(this.categoryId)]; //FIXME - Add checking here for valid colors
    },
    timeSinceLastBlock() {
      // FIXME - DEAL WITH CHILDREN
      const includeChildren = !categoryUtil.getShowChildren(this.categoryId);
      let ts = categoryUtil.getLastBlockAddedTs(this.categoryId, includeChildren);
      if (ts > this.now) {
        ts = this.now;
      }

      //FIXME - Make this better/not rely on an arbitrary time/date where we implemented this
      return ts
        ? "Last block was added " + moment(ts).from(this.now)
        : "We're not sure when you last added a block ¯\\_(ツ)_/¯ ";
    },
    includeChildren() {
      return !categoryUtil.getSubcategoryVisibility(this.categoryId);
    },
    categoryTotals() {
      let total = categoryUtil.getTotalSummary(this.categoryId, this.includeChildren);
      let year = categoryUtil.getThisYearSummary(this.categoryId, this.includeChildren);
      let month = categoryUtil.getThisMonthSummary(this.categoryId, this.includeChildren);
      let day = categoryUtil.getCompletedToday(this.categoryId, this.includeChildren);

      let summary = {
        total,
        year,
        month,
        day,
      };

      if (util.isMobile()) {
        delete summary.total;
        delete summary.year;
      }

      return summary;
    },
  },
};
</script>

<style scoped>
/* FIXME - MAKE SURE WE ARE NOT DEPENDING ON STYLES FROM OTHER COMPONENTS, IE CATEGORYDETAILSBLOCK */

.category-info {
  cursor: initial;
}

.category-info.flexRow {
  display: flex; /* REMOVE THIS AFTER WE FIX THE STUPID CLASS ISSUES */
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.editIcon {
  position: relative;
  top: 2px;
}

.metadata.flexRow {
  align-items: flex-start;
}

.metadata .block {
  margin: 0.5rem;
}

.metadataHeader.flexRow {
  flex-direction: column;
  align-items: flex-start;
}

.categoryStats {
  border-top: 1px solid #eee;
  margin: 0.25rem;
  padding: 0.25rem;
  justify-content: center;
}

.categoryStats .label {
  width: 3rem;
  border-right: 1px solid #eee;
  padding: 0.5rem 0;
  padding-right: 0.375rem;
}

.categoryStats .countBlock {
  margin: 0.5rem 0;
  padding: 0.5rem 0.375rem;
  text-align: center;
  width: 2rem;
  /*border: 1px solid #eee;*/
  /*border-top: none;*/
  /*border-bottom: none;*/
}

.categoryStats .timeframe {
  font-size: 0.7rem;
}

.lastBlock {
  font-size: 0.75rem;
}

@media (max-width: 600px) {
  /*FILLMEIN*/
}
</style>



// WEBPACK FOOTER //
// CategoryDetails.vue?57300cf3